import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft, FaUpload } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import {
  headersProgEspecializadoResumo,
  offCanvasProgramacao,
} from './auxliarEspecializado';
import SubAbasProgEspecializado from './subabasProgEspecializado';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import CardFase from '../../../../components/CardFase';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getNotaVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getProdutoPorComponente } from '../../../../services/produtosDAF/produtosDafService';
import theme from '../../../../theme';
import {
  calculateColumnWidth,
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
//const entity = ENTITY.ENTITY_Contratos;

export default function ProgEspecializadoFicha() {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  // const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formNotaVersao, setFormNotaVersao] = useState({
    usuarioId: userID,
    statusVersao: '',
    dataVersao: '',
    tagVersao: '',
    descricao: '',
    link: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getNotaVersao(id);
      setLogData(registroData);
      setFormNotaVersao({
        usuarioId: userID,
        statusVersao: registroData.statusVersao,
        dataVersao: registroData.dataVersao,
        tagVersao: registroData.tagVersao,
        descricao: registroData.descricao,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const [produtos, setProdutos] = useState([]);
  useEffect(() => {
    const fetchProdutos = async () => {
      const produtos = await getProdutoPorComponente('especializado');

      setProdutos(produtos);
      // setDataOffCanvas(offcavnasFormatado);
    };

    fetchProdutos();
  }, []);

  const tabelaFormatada = produtos.map(
    (produto: { id: number; produtofarmaceutico: string }) => ({
      id: 'P252DF-' + produto.id,
      produtoFarmaceutico: produto.produtofarmaceutico,
      ses_necessidade: '',
      total_aprovado: '',
      total_enviado: '',
      total_entregue: '',
      upload: (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={() => console.log('Upload', produto.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: theme.colors.azulgov,
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 12px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0056b3';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = theme.colors.azulgov;
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
            }}
          >
            <FaUpload />
            Upload
          </button>
        </div>
      ),
    }),
  );

  const offcanvasFormatado = produtos.map(
    (produto: { id: number; produtofarmaceutico: string }) => ({
      id: 'P252DF-' + produto.id,

      produtoFarmaceutico: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: theme.colors.azulgov,
              borderRadius: '10px',
              padding: '10px',
              color: 'white',
              marginLeft: '0px',
            }}
          >
            {produto.produtofarmaceutico}
          </span>
        </div>
      ),
      obm: '@brasil25224574230',
      separadorProduto: '',
      listaPacienteObrigatoria: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: theme.colors.verdegov,
              borderRadius: '10px',
              padding: '10px',
              color: 'white',
              marginLeft: '0px',
            }}
          >
            Sim
          </span>
        </div>
      ),
      modeloLista: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              color: 'blue',
              textDecoration: 'underline',
              marginLeft: '0px',
            }}
          >
            Download .xlsx
          </span>
        </div>
      ),
      upload: (
        <button
          onClick={() => alert('Upload')}
          style={{
            borderRadius: '10px',
            padding: '5px',
            marginLeft: '0px',
          }}
        >
          Upload
        </button>
      ),
      download: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              color: 'blue',
              textDecoration: 'underline',
              marginLeft: '0px',
            }}
          >
            Download .xlsx
          </span>
        </div>
      ),
      ses_pacientes: 2.795,
      pacientesValidados: 2.456,
      separadorPacientes: '',
      ses_consumo_pacientes: '150.000',
      ses_estoque: '50.000',
      ses_necessidade: '100.000',
      separadorDemanda: '',
      total_aprovado: '100.000',
      criterioAprovacao: 'Lista de Pacientes',
      total_enviado: '80.000 (80,0%)',
      total_entregue: '50.000 (50,0%)',
      separadorRegra: '',
      regraValidacao: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span style={{ marginLeft: '0px' }}>
            Validação geral<br></br>- CNS: se existe e não está duplicado
            <br></br>- CPF: se CPF existe e não está duplicado<br></br>- Data de
            nascimento 0 ou maior que 120<br></br>- Nome: bate com CNS (não
            muito criterioso)<br></br>- Vivo morto: se está vivo<br></br>-
            Quando houver peso: limite mínimo: menor que 1 e maior que 300
          </span>
        </div>
      ),
    }),
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    console.log('Status:', formNotaVersao.statusVersao);

    const status = String(formNotaVersao.statusVersao);
    console.log('Status atual:', status); // Adicionado para depurar

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formNotaVersao.statusVersao]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDateReadOnly, setIsDateReadOnly] = useState(true);
  useEffect(() => {
    if (
      formNotaVersao.statusVersao == '1' ||
      formNotaVersao.statusVersao == '3'
    ) {
      setIsDateReadOnly(true);
      setFormNotaVersao((prev) => ({
        ...prev,
        dataVersao: '',
      }));
    } else {
      setIsDateReadOnly(false);
    }
  }, [formNotaVersao.statusVersao]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasProgEspecializado(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/secsaude/programacao/especializado/ficha/dadosgerais`,
      },
      {
        label: 'Notificações',
        rota: `/secsaude/programacao/especializado/ficha/notificacoes`,
      },
      {
        label: 'Entregas',
        rota: `/secsaude/programacao/especializado/ficha/entregas`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    console.log('Campo alterado:', name, 'Novo valor:', value); // Verificar qual campo está sendo alterado e o valor
    setFormNotaVersao((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusVersao) {
      errors.push('<b>Status da versão</b> é obrigatório.');
    }

    if (!form.tagVersao) {
      errors.push('Nome da <b>tag da versão</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (form.statusVersao == '2' && form.dataVersao == '') {
      errors.push('<b>Data da versão</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      console.log(formNotaVersao);

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/notaversaosisaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/notas/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      const response = await httpClient.patch(
        `/api/notaversaosisaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const fluxoProgramacaoFaseData = [
    {
      id: 1,
      dataRegistro: '2025-05-01T17:31:42.568Z',
      dataUltimaAtualizacao: '2025-05-01T17:31:42.568Z',
      dataUltimaVisualizacao: '2025-05-01T17:31:42.568Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      ordem: 1,
      estimativaDias: 14,
      nomeFase: 'Programação',
      areaResponsavel: null,
      descricao:
        'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
      observacoes: 'Sem observações',
      stRegistroAtivo: 'S',
    },
    {
      id: 2,
      dataRegistro: '2025-05-01T17:31:42.568Z',
      dataUltimaAtualizacao: '2025-05-01T17:31:42.568Z',
      dataUltimaVisualizacao: '2025-05-01T17:31:42.568Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      ordem: 1,
      estimativaDias: 14,
      nomeFase: 'Validação MS',
      areaResponsavel: null,
      descricao:
        'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
      observacoes: 'Sem observações',
      stRegistroAtivo: 'S',
    },
    {
      id: 3,
      dataRegistro: '2025-05-01T17:31:42.568Z',
      dataUltimaAtualizacao: '2025-05-01T17:31:42.568Z',
      dataUltimaVisualizacao: '2025-05-01T17:31:42.568Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      ordem: 1,
      estimativaDias: 14,
      nomeFase: 'Retificação',
      areaResponsavel: null,
      descricao:
        'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
      observacoes: 'Sem observações',
      stRegistroAtivo: 'S',
    },
    {
      id: 4,
      dataRegistro: '2025-05-01T17:31:42.568Z',
      dataUltimaAtualizacao: '2025-05-01T17:31:42.568Z',
      dataUltimaVisualizacao: '2025-05-01T17:31:42.568Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      ordem: 1,
      estimativaDias: 14,
      nomeFase: 'Execução',
      areaResponsavel: null,
      descricao:
        'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
      observacoes: 'Sem observações',
      stRegistroAtivo: 'S',
    },
    {
      id: 5,
      dataRegistro: '2025-05-01T17:31:42.568Z',
      dataUltimaAtualizacao: '2025-05-01T17:31:42.568Z',
      dataUltimaVisualizacao: '2025-05-01T17:31:42.568Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      ordem: 1,
      estimativaDias: 14,
      nomeFase: 'Complementação',
      areaResponsavel: null,
      descricao:
        'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
      observacoes: 'Sem observações',
      stRegistroAtivo: 'S',
    },
  ];

  const programacaoFaseData = [
    {
      id: 1,
      dataRegistro: '2025-05-01T16:32:34.637Z',
      dataUltimaAtualizacao: '2025-05-01T16:32:34.637Z',
      dataUltimaVisualizacao: '2025-05-01T16:32:34.637Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      faseOrdem: 1,
      dataEntrada: '2025-04-18',
      dataSaida: '2025-05-01',
      observacoes: 'Nenhuma observação específica.',
      stRegistroAtivo: 'S',
    },
    {
      id: 2,
      dataRegistro: '2025-05-01T16:32:34.637Z',
      dataUltimaAtualizacao: '2025-05-01T16:32:34.637Z',
      dataUltimaVisualizacao: '2025-05-01T16:32:34.637Z',
      nEdicoes: 1,
      nVisualizacoes: 1,
      nVisualizadores: 1,
      faseOrdem: 1,
      dataEntrada: '2025-05-01',
      dataSaida: null,
      observacoes: 'Nenhuma observação específica.',
      stRegistroAtivo: 'S',
    },
  ];

  const programacaoFaseStateArray = [true, true];

  function calculateDays(faseInfo: any) {
    if (!faseInfo.dataEntrada) return '-';

    const dataEntrada = new Date(faseInfo.dataEntrada);

    if (faseInfo.dataSaida) {
      const dataSaida = new Date(faseInfo.dataSaida);
      return Math.round(
        (dataSaida.getTime() - dataEntrada.getTime()) / (1000 * 60 * 60 * 24) +
          1,
      ).toString();
    }

    return Math.round(
      (new Date().getTime() - dataEntrada.getTime()) / (1000 * 60 * 60 * 24),
    ).toString();
  }

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/secsaude/programacao/especializado"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Evolução da Programação">
            {/* Evolução - Cards */}
            <CustomRow
              className="g-0"
              style={{
                marginBottom: '15px',
                justifyContent: 'center',
                justifyItems: 'center',
                alignItems: 'center',
              }}
            >
              {fluxoProgramacaoFaseData &&
                fluxoProgramacaoFaseData.map((item, index) => {
                  const programacaoFaseInfo = programacaoFaseData[index] ?? {};
                  const programacaoFaseState =
                    programacaoFaseStateArray?.[index] ?? false;
                  const isUltimoAtivo =
                    index + 1 === programacaoFaseStateArray.length;

                  return (
                    <CustomCol
                      // width={'12.5%'}
                      width={calculateColumnWidth(
                        fluxoProgramacaoFaseData.length,
                      )}
                      className="mb-3"
                      key={item.id}
                      style={{ maxWidth: '12.5%' }}
                    >
                      <CardFase
                        key={item.ordem}
                        onClick={() => {
                          if (programacaoFaseData.length >= item.ordem) {
                            // handleCardClickFase(item.ordem, item.id);
                            alert('abrir ficha da fase!');
                          } else {
                            // handleShowModalFaseEvolucao();
                            alert(
                              'abrir modal para lista de fases da programação',
                            );
                          }
                        }}
                        titulo={item.nomeFase}
                        status={programacaoFaseState}
                        isUltimoItem={
                          isUltimoAtivo && !programacaoFaseInfo.dataSaida
                        }
                        dataEntrada={
                          programacaoFaseInfo.dataEntrada
                            ? formatDateSimp(programacaoFaseInfo.dataEntrada)
                            : '-'
                        }
                        dataSaida={
                          programacaoFaseInfo.dataSaida
                            ? formatDateSimp(programacaoFaseInfo.dataSaida)
                            : '-'
                        }
                        dias={calculateDays(programacaoFaseInfo)}
                        // areaResponsavel={responsavel}
                        // style={{ maxWidth: '200px' }}
                      />
                    </CustomCol>
                  );
                })}
            </CustomRow>
            <Col className="d-flex justify-content-end gap-2">
              <CustomButton
                label="Info"
                bgColor={theme.colors.botaoAcao.cinza} // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={() =>
                  console.log('Abrir informações das fases da programação')
                }
                // onClick={handleShowModalProgramacaoFaseInfo}
                disabled={fluxoProgramacaoFaseData.length > 0 ? false : true}
              />
              <CustomButton
                label="Editar"
                bgColor={theme.colors.botaoAcao.amarelo}
                textColor="#ffffff" // Texto branco
                // onClick={handleShowModalFaseEvolucao}
                onClick={() => console.log('Editar fases da programação')}
                disabled={fluxoProgramacaoFaseData.length > 0 ? false : true}
              />
            </Col>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Identificação da Programação">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="150px">
                <Input
                  name="link"
                  label="ID da Programação"
                  value="P252DF"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'center' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="link"
                  label="Status"
                  value="Em Programação"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'center' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="100px">
                <Input
                  name="link"
                  label="Ano"
                  value="2025"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'center' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="100px">
                <Input
                  name="link"
                  label="Trimestre"
                  value="2"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'center' }}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="link"
                  label="Secretaria"
                  value="Secretaria de Estado de Saúde do Distrito Federal"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'left' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Programação de Envio de Produtos Farmacêuticos">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <BoxConteudo boxTitulo="Lista de Produtos">
                <CustomCol width="100%">
                  <Tabela
                    headers={headersProgEspecializadoResumo}
                    dataTable={tabelaFormatada}
                    displayValues={offCanvasProgramacao}
                    dataOffCanvas={offcanvasFormatado}
                    showPagination={false}
                    rowClickable={false}
                    itemsPerPage={500}
                    botaoAbrirOffCanvas={false}
                  />
                </CustomCol>
              </BoxConteudo>
            </CustomRow>
            <CustomRow style={{ justifyContent: 'flex-end' }}>
              <WorkspaceBotoes upload />
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Documento de Solicitação">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            ></CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
